import { render, staticRenderFns } from "./AdvisoryFunds.vue?vue&type=template&id=b84f5f3a&scoped=true"
import script from "./AdvisoryFunds.vue?vue&type=script&lang=ts"
export * from "./AdvisoryFunds.vue?vue&type=script&lang=ts"
import style0 from "./AdvisoryFunds.vue?vue&type=style&index=0&id=b84f5f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84f5f3a",
  null
  
)

export default component.exports